












import Vue from 'vue'
import UiStep from './step.vue'
interface IStep {
  label: string
}
export default Vue.extend({
  props: {
    steps: Array as () => IStep[],
    active: Number
  },
  components: {
    UiStep
  },
  data () {
    return {
    }
  }
})
